/**
 * @flow
 * @relayHash 55bfc6c62653d6680796998b513543a7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VocabularyAddInput = {
  name: string,
  value: string,
  description: string,
  canDelete: boolean,
  clientMutationId?: ?string,
};
export type vocabularyAddMutationVariables = {|
  input: VocabularyAddInput
|};
export type vocabularyAddMutationResponse = {|
  +VocabularyAdd: ?{|
    +error: ?string,
    +vocabularyEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type vocabularyAddMutation = {|
  variables: vocabularyAddMutationVariables,
  response: vocabularyAddMutationResponse,
|};
*/


/*
mutation vocabularyAddMutation(
  $input: VocabularyAddInput!
) {
  VocabularyAdd(input: $input) {
    error
    vocabularyEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VocabularyAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "VocabularyAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "VocabularyAddInput!"
      }
    ],
    "concreteType": "VocabularyAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vocabularyEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "VocabularyEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Vocabulary",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "vocabularyAddMutation",
  "id": null,
  "text": "mutation vocabularyAddMutation(\n  $input: VocabularyAddInput!\n) {\n  VocabularyAdd(input: $input) {\n    error\n    vocabularyEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "vocabularyAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "vocabularyAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cd194f65ea754123eeb5d4e36aeb5cd1';
module.exports = node;



// WEBPACK FOOTER //
// src/components/vocabulary/mutations/__generated__/vocabularyAddMutation.graphql.js